const extendedFieldActions = {
  SET_GROUP_ID: "SET_GROUP_ID",
  /**
   * Sets the group id that is used to interact with the api.
   * @param {number} groupId
   */
  setGroupId: (groupId) => ({
    type: extendedFieldActions.SET_GROUP_ID,
    groupId,
  }),
  SET_SIGNUP_ITEM_ID: "SET_SIGNUP_ITEM_ID",
  setSignupItemId: (signupItemId) => ({
    type: extendedFieldActions.SET_SIGNUP_ITEM_ID,
    signupItemId,
  }),
  SET_EXTENDED_FIELDS: "SET_EXTENDED_FIELDS",
  /**
   * Sets the extended field data, presumably from the api endpoint.
   * @param {object} extendedFields
   */
  setExtendedFields: (extendedFields) => ({
    type: extendedFieldActions.SET_EXTENDED_FIELDS,
    extendedFields,
  }),
  INIT_EXTENDED_FIELDS: "INIT_EXTENDED_FIELDS",
  /**
   * initializes the getExtendedFields endpoint
   */
  initExtendedFields: () => ({
    type: extendedFieldActions.INIT_EXTENDED_FIELDS,
  }),
  CLEAR_FIELD_DATA: "CLEAR_FIELD_DATA",
  clearFieldData: () => ({
    type: extendedFieldActions.CLEAR_FIELD_DATA,
  }),
  CLEAR_FIELD_DATA_ON_SAVE: "CLEAR_FIELD_DATA_ON_SAVE",
  clearFieldDataOnSave: () => ({
    type: extendedFieldActions.CLEAR_FIELD_DATA_ON_SAVE,
  }),
  SET_SELECTED_FIELD_ID: "SET_SELECTED_FIELD_ID",
  /**
   * Sets the networkFieldID that is currenly selected for editing.
   * @param {number} fieldId
   */
  setSelectedFieldId: (networkFieldID) => ({
    type: extendedFieldActions.SET_SELECTED_FIELD_ID,
    networkFieldID,
  }),
  INIT_SELECTED_FIELD: "INIT_SELECTED_FIELD",
  initSelectedField: (fieldData) => ({
    type: extendedFieldActions.INIT_SELECTED_FIELD,
    fieldData,
  }),
  SET_ICON: "SET_ICON",
  /**
   * Sets the icon that will be sent to [enableExtendedField|create] via the property "icon".
   * @param {number} fieldId
   */
  setIcon: (icon) => ({
    type: extendedFieldActions.SET_ICON,
    icon,
  }),
  SET_TITLE: "SET_TITLE",
  setTitle: (title) => ({
    type: extendedFieldActions.SET_TITLE,
    title,
  }),
  SET_REQUIRED: "SET_REQUIRED",
  setRequired: (required) => ({
    type: extendedFieldActions.SET_REQUIRED,
    required,
  }),
  SET_VIEW_PERMISSION_ID: "SET_VIEW_PERMISSION_ID",
  /**
   * Sets the id to be sent to [enableExtendedField|create] via the property "fieldResponseViewPermissionID"
   * @param {number} fieldResponseViewPermissionID
   */
  setViewPermissionID: (fieldResponseViewPermissionID) => ({
    type: extendedFieldActions.SET_VIEW_PERMISSION_ID,
    fieldResponseViewPermissionID,
  }),
  SET_EDIT_PERMISSION_ID: "SET_EDIT_PERMISSION_ID",
  /**
   * Sets the id to be sent to [enableExtendedField|create] via the property "fieldResponseEditPermissionID"
   * @param {number} fieldResponseEditPermissionID
   */
  setEditPermissionID: (fieldResponseEditPermissionID) => ({
    type: extendedFieldActions.SET_EDIT_PERMISSION_ID,
    fieldResponseEditPermissionID,
  }),
  SET_SHOW_ON_SIGNUP: "SET_SHOW_ON_SIGNUP",
  /**
   * Sets the value to be sent to [enableExtendedField|create] via the property "showOnSignup"
   * @param {number} showOnSignUp
   * @returns
   */
  setShowOnSignUp: (showOnSignUp) => ({
    type: extendedFieldActions.SET_SHOW_ON_SIGNUP,
    showOnSignUp,
  }),
  SET_IIG: "SET_IIG",
  /**
   * Sets the value to be sent to [enableExtendedField|create] via the property "enableIIG"
   * @param {number} iigOn
   * @returns
   */
  setIig: (iigOn) => ({
    type: extendedFieldActions.SET_IIG,
    iigOn,
  }),
  SET_PERIODIC_IIG: "SET_PERIODIC_IIG",
  /**
   * Sets the value to be sent to [enableExtendedField|create] via the property "enablePeriodicIIG"
   * @param {number} periodicIIGOn
   * @returns
   */
  setPeriodicIig: (periodicIIGOn) => ({
    type: extendedFieldActions.SET_PERIODIC_IIG,
    periodicIIGOn,
  }),
  SET_SHARE_WITH: "SET_SHARE_WITH",
  /**
   * Sets the values to be sent to [enableExtendedField|create] via the properties "shareWithHousehold" and "shareWithSpouse"
   * @param {"none"|"household"|"spouse"} shareWith
   */
  setShareWith: (fieldResponseEntity) => ({
    type: extendedFieldActions.SET_SHARE_WITH,
    fieldResponseEntity,
  }),
  SET_MULTILINE: "SET_MULTILINE",
  /**
   * Sets the values to be sent to [enableExtendedField|create] via the property configuration: {behaviorOptions: {displayAs: 'multi'}}
   * @param {boolean} multiline
   */
  setMultiline: (multiline) => ({
    type: extendedFieldActions.SET_MULTILINE,
    multiline,
  }),
  SET_MIN: "SET_MIN",
  /**
   * Sets the values to be sent to [enableExtendedField|create] via the property configuration: {responseOptions: {min: number}}
   * @param {number} min
   */
  setMin: (min) => ({
    type: extendedFieldActions.SET_MIN,
    min,
  }),
  SET_MAX: "SET_MAX",
  /**
   * Sets the values to be sent to [enableExtendedField|create] via the property configuration: {responseOptions: {max: number}}
   * @param {number} max
   */
  setMax: (max) => ({
    type: extendedFieldActions.SET_MAX,
    max,
  }),
  SET_CHANGE_COUNTRY: "SET_CHANGE_COUNTRY",
  /**
   * Sets the values to be sent to [enableExtendedField|create] via the property configuration: {subfields: {addr1: {isVisible: 1}, city: {isVisible: 1}, state: {isVisible: 1}, zip: {isVisible: 1}, country: {isVisible: 0|1}}}
   * @param {boolean} changeCountry
   */
  setChangeCountry: (changeCountry) => ({
    type: extendedFieldActions.SET_CHANGE_COUNTRY,
    changeCountry,
  }),
  SET_DEFAULT_COUNTRY: "SET_DEFAULT_COUNTRY",
  /**
   * Sets the values to be sent to [enableExtendedField|create] via the property configuration: {responseOptions: {default: {country: string}}}
   * @param {string} defaultCountry
   */
  setDefaultCountry: (defaultCountry) => ({
    type: extendedFieldActions.SET_DEFAULT_COUNTRY,
    defaultCountry,
  }),
  SET_INCLUDE_YEAR: "SET_INCLUDE_YEAR",
  /**
   * Sets the values to be sent to [enableExtendedField|create] via the property configuration: {subfields: {year: {isVisible: 1|0}}}
   * @param {boolean} includeYear
   */
  setIncludeYear: (includeYear) => ({
    type: extendedFieldActions.SET_INCLUDE_YEAR,
    includeYear,
  }),
  SET_OPTIONS: "SET_OPTIONS",
  /**
   * Sets the values to be sent to [enableExtendedField|create] via the property configuration: {responseOptions: {responseOptionList: [{optionListValue: string, optionListValueID: number}]}}
   * @param {[string]} options
   */
  setOptions: (options = []) => ({
    type: extendedFieldActions.SET_OPTIONS,
    options,
  }),
  SET_MULTI_OPTIONS: "SET_MULTI_OPTIONS",
  /**
   * Sets the values to be sent to [enableExtendedField|create] via the property configuration: {behaviorOptions: {allowMultiple: boolean}}
   * @param {boolean} multiOptions
   */
  setMultiOptions: (multiOptions) => ({
    type: extendedFieldActions.SET_MULTI_OPTIONS,
    multiOptions,
  }),
  SET_IS_NAVIGATING: "SET_IS_NAVIGATING",
  setIsNavigating: (isNavigating) => ({
    type: extendedFieldActions.SET_IS_NAVIGATING,
    isNavigating,
  }),
  SET_ERROR_MESSAGE: "SET_ERROR_MESSAGE",
  setErrorMessage: (errorMessage) => ({
    type: extendedFieldActions.SET_ERROR_MESSAGE,
    errorMessage,
  }),
  SET_DISPLAY_IS_FULL_WIDTH: "SET_DISPLAY_IS_FULL_WIDTH",
  setDisplayIsFullWidth: (displayIsFullWidth) => ({
    type: extendedFieldActions.SET_DISPLAY_IS_FULL_WIDTH,
    displayIsFullWidth,
  }),
  SET_IS_EVERYONE_GROUP: "SET_IS_EVERYONE_GROUP",
  setIsEveryoneGroup: (isEveryoneGroup) => ({
    type: extendedFieldActions.SET_IS_EVERYONE_GROUP,
    isEveryoneGroup,
  }),
  SET_EDIT_WIDTH_MODAL: "SET_EDIT_WIDTH_MODAL",
  setEditWithModal: (editWithModal) => ({
    type: extendedFieldActions.SET_EDIT_WIDTH_MODAL,
    editWithModal,
  }),
  SET_IS_REFRESHING: "SET_IS_REFRESHING",
  setIsRefreshing: (isRefreshing) => ({
    type: extendedFieldActions.SET_IS_REFRESHING,
    isRefreshing,
  }),
};

export default extendedFieldActions;
